import React from 'react';
import {Route, BrowserRouter as Router} from 'react-router-dom'
import { Patient } from '../pages/faq/patient';
import { Provider } from '../pages/faq/provider';
import { Secretariat } from '../pages/faq/secretariat';
import { Surgeon } from '../pages/faq/surgeon';
import { Privacity } from '../pages/privacity';

const Routes: React.FC = () => {
  return (
      <Router>
        <Route path='/' exact component={Privacity}/>
        <Route path='/faq/patients' exact component={Patient}/>
        <Route path='/faq/surgeon' exact component={Surgeon}/>
        <Route path='/faq/secretariat' exact component={Secretariat}/>
        <Route path='/faq/provider' exact component={Provider}/>
      </Router>
  );
}

export default Routes;